<template>
  <div class="all_order">
    <div class="condition">
      <div class="order_steps"></div>
      <!-- <div style="background: #eef0f3; height: 10px"></div> -->
      <div class="check_type">
        <div class="check_item" v-for="(item, index) in orderType" :key="index"
          :class="{ order_type_isSelected: item.isSelected }" @click="checkOrderType(item)">
          {{ item.name }}
        </div>
        <div class="erji_item">
          <div class="daiyuyue" v-if="subscribe" style="margin-top: 8px">
            <el-button class="er_btns" v-for="item in subscribeList" :class="{ er_selected: item.isSelected }"
              @click="subscribeCheck(item)">{{ item.name }}</el-button>
          </div>
          <div class="fuwuzhong" v-if="inService" style="margin-top: 8px">
            <el-button class="er_btns" v-for="item in inServiceList" :class="{ er_selected: item.isSelected }"
              @click="inServiceCheck(item)">{{ item.name }}</el-button>
          </div>
        </div>
      </div>

      <div class="screen_input">
        <div id="range_date">
          下单时间
          <el-date-picker class="screen range_date" v-model="timeSlot" type="daterange" align="right" unlink-panels
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </div>
        <div>
          客户信息
          <el-input class="screen" v-model="params.customer" placeholder="请输入客户姓名或手机号"></el-input>
        </div>
        <div>
          师傅信息
          <el-input class="screen" v-model="params.worker" placeholder="请输入师傅姓名或手机号"></el-input>
        </div>
        <template v-if="toggleSearchStatus">
          <div>
            有无异常
            <el-select class="screen" v-model="params.isGoodsAbnormal" placeholder="请选择" @change="checkSelect">
              <el-option v-for="item in abnormalList" :key="item.value" :label="item.name"
                :value="item.value"></el-option>
            </el-select>
          </div>
          <div>
            订单编号
            <el-input class="screen" v-model="params.orderNo" placeholder="请输入订单编号" type="number"></el-input>
          </div>

          <div>
            商品类目
            <el-select class="screen" v-model="params.goodsTypeName" placeholder="请选择" @change="checkSelect">
              <el-option v-for="item in categoryCommodities" :key="item.id" :label="item.name"
                :value="item.name"></el-option>
            </el-select>
          </div>

          <div>
            是否完工
            <el-select class="screen" v-model="params.isFinish" placeholder="请选择" @change="checkSelect">
              <el-option v-for="item in finishedList" :key="item.value" :label="item.name"
                :value="item.value"></el-option>
            </el-select>
          </div>

          <div>
            物流单号
            <el-input class="screen" v-model="params.logisticsNo" placeholder="请输入物流单号"
              @input="$forceUpdate()"></el-input>
          </div>

          <div>
            是否到货
            <el-select class="screen" v-model="params.isArrival" placeholder="请选择" @change="checkSelect">
              <el-option v-for="item in finishedList" :key="item.value" :label="item.name"
                :value="item.value"></el-option>
            </el-select>
          </div>

          <div>
            预约结果
            <el-select class="screen" v-model="params.appointResult" placeholder="请选择" @change="checkSelect">
              <el-option key="true" label="预约成功" value="true"></el-option>
              <el-option key="false" label="预约失败" value="false"></el-option>
            </el-select>
          </div>

          <div>
            客户区域
            <el-cascader class="screen" v-model="params.areaCodeList" :options="cityOptions" :props="{
              checkStrictly: true,
              expandTrigger: 'hover',
              value: 'code',
              label: 'name',
            }" placeholder="请选择" clearable filterable></el-cascader>
          </div>

          <div id="range_date">
            完工时间
            <el-date-picker class="screen range_date" v-model="completeTime" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </div>
        </template>
      </div>
      <div class="order_btns">
        <el-button class="order_search" @click="isorderSearch()">搜索</el-button>
        <el-button class="order_clear" @click="orderClear()">重置</el-button>
        <el-button class="order_clear" v-loading="exportLoading" @click="exportExcel('订单列表')">导出数据</el-button>
        <a @click="toggleSearchStatus = !toggleSearchStatus" style="margin-left: 8px">
          {{ toggleSearchStatus ? "收起" : "展开" }}
          <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
        </a>
      </div>
    </div>

    <div class="order-list">
      <order-list :orderItems="orderItems" v-on:pagesize="pagesize" @ok="orderSearch" ref="orderList"></order-list>
    </div>
  </div>
</template>

<script>
  import orderList from "./order_list";
  import { downloadFile, downFile } from "@/api/manage";

  export default {
    components: {
      orderList,
    },
    data() {
      return {
        exportLoading: false,
        abnormal: false,
        subscribe: false,
        inService: false,
        orderType: [
          { name: "全部", isSelected: true, status: "" },
          { name: "待付款", isSelected: false, status: "WAIT_PAY" },
          { name: "未到货", isSelected: false, status: "" },
          { name: "接单中", isSelected: false, status: "RECEIVING_ORDER" },
          { name: "待预约", isSelected: false, status: "WAIT_APPOINTMENT" },
          { name: "服务中", isSelected: false, status: "INSERVICE" },
          { name: "待验收", isSelected: false, status: "WAIT_ACCEPT" },
          // { name: "异常订单", isSelected: false, status: "" },
          // { name: "待评价", isSelected: false, status: "WAIT_EVALUATE" },
          { name: "交易成功", isSelected: false, status: "DEAL" },
          { name: "退款审核", isSelected: false, status: "WAIT" },
          { name: "退款拒绝", isSelected: false, status: "REFUSE" },
          { name: "退款成功", isSelected: false, status: "REFUND_SUEECSS" },
        ],
        subscribeList: [
          { name: "全部", isSelected: true },
          { name: "未到货", isSelected: false },
        ],
        inServiceList: [
          { name: "全部", isSelected: true, status: "INSERVICE" },
          { name: "待提货", isSelected: false, status: "WAIT_PICK_UP" },
          { name: "待上门", isSelected: false, status: "WAIT_INSTALL" },
          { name: "待完工", isSelected: false, status: "WAIT_COMPLETE" },
        ],
        input: "",
        options: [],
        toggleSearchStatus: true,
        abnormalList: [
          { value: true, name: "有" },
          { value: false, name: "无" },
        ],
        finishedList: [
          { value: true, name: "是" },
          { value: false, name: "否" },
        ],
        pickerOptions: {
          shortcuts: [
            {
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              },
            },
          ],
        },
        timeSlot: ["", ""],
        completeTime: ['', ''],
        orderItems: {},
        page: "1",
        params: {
          pageNum: 1,
          pageSize: 6,
          orderNo: "", //订单号
          customer: "", //客户姓名或手机
          worker: "", //师傅姓名或手机
          status: "",
          startTime: "",
          endTime: "",
          isArrival: "", //是否到货
          isGoodsAbnormal: "", //是否异常
        },
        flag: 1,
        categoryCommodities: [],
        cityOptions: [],
      };
    },
    activated() {
      var _this = this;
      for (let i of _this.$store.state.userList) {
        i.isSelected = false;
        if (i.name == "全部订单") {
          i.isSelected = true;
        }
      }
      if (Cookies.get("token") != undefined) {
        this.getCitys();
        this.$post(`/order/api/order/status`).then((res) => {
          if (res.code == 0) {
            _this.options = res.data;
          } else {
            this.$message(res.message);
          }
        });
        _this.orderSearch();
        this.getGoodsType();
      }
    },

    methods: {
      // 下载我的商品
      exportExcel(fileName) {
        if (!fileName || typeof fileName != "string") {
          fileName = "导出文件";
        }
        this.exportLoading = true;
        let _this = this
        let params = {};
        _this.params.startTime = _this.timeSlot[0];
        if (_this.timeSlot[1]) {
          _this.params.endTime = _this.timeSlot[1].split(" ")[0] + " 23:59:59";
        }
        // 完工时间
        _this.params.completeStartTime = _this.completeTime[0];
        if (_this.completeTime[1]) {
          _this.params.completeEndTime = _this.completeTime[1].split(" ")[0] + " 23:59:59";
        }

        if (this.params.areaCodeList) {
          this.params.areaCode =
            this.params.areaCodeList[this.params.areaCodeList.length - 1];
          // delete this.params.areaCodeList
        }
        for (let i in _this.params) {
          if (_this.params[i].length != 0) {
            params[i] = _this.params[i];
          }
        }
        downFile("/order/api/order/export", params).then(({ data }) => {
          if (!data) {
            this.$message.warning("文件下载失败");
            return;
          }
          if (typeof window.navigator.msSaveBlob !== "undefined") {
            window.navigator.msSaveBlob(
              new Blob([data], { type: "application/vnd.ms-excel" }),
              fileName + ".xls"
            );
          } else {
            let url = window.URL.createObjectURL(
              new Blob([data], { type: "application/vnd.ms-excel" })
            );
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", fileName + ".xls");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
          }
        }).finally(
          () => (this.exportLoading = false)
        )
      },
      exportExcel1() {
        this.exportLoading = true;
        let _this = this
        let params = {};
        _this.params.startTime = _this.timeSlot[0];
        if (_this.timeSlot[1]) {
          _this.params.endTime = _this.timeSlot[1].split(" ")[0] + " 23:59:59";
        }
        // 完工时间
        _this.params.completeStartTime = _this.completeTime[0];
        if (_this.completeTime[1]) {
          _this.params.completeEndTime = _this.completeTime[1].split(" ")[0] + " 23:59:59";
        }

        if (this.params.areaCodeList) {
          this.params.areaCode =
            this.params.areaCodeList[this.params.areaCodeList.length - 1];
          // delete this.params.areaCodeList
        }
        for (let i in _this.params) {
          if (_this.params[i].length != 0) {
            params[i] = _this.params[i];
          }
        }
        downloadFile("/order/api/order/export", "订单列表.xls", params).finally(
          () => (this.exportLoading = false)
        );
      },
      // 获取城市
      getCitys() {
        this.$fetch(`/common/api/area`).then((res) => {
          if (res.code == 0) {
            this.cityOptions = res.data;
          } else {
            this.$message(res.message);
          }
        });
      },
      getGoodsType() {
        let _this = this;
        // 获取商品类目
        this.$fetch(`/common/api/goods_type/top_class`).then((res) => {
          if (res.code == 0) {
            res.data.map((i) => {
              i.isSelected = false;
              if (i.id == this.$store.state.immediateData.goodsTypeId) {
                i.isSelected = true;
              }
            });
            _this.categoryCommodities = res.data;
          } else {
            this.$message(res.message);
          }
        });
      },
      pagesize(val) {
        this.params.pageNum = val;
        this.orderSearch();
      },
      // 下拉选择
      checkSelect() {
        for (let i of this.orderType) {
          i.isSelected = false;
          if (i.name == "全部") {
            i.isSelected = true;
          }
        }
      },
      checkOrderType(item) {
        console.log(item);
        if (item.name == "待付款") this.$refs.orderList.batchPayBtn = true;
        else this.$refs.orderList.batchPayBtn = false;
        // this.params.isArrival = false;
        for (let i of this.orderType) {
          i.isSelected = false;
        }
        this.params.pageNum = 1;
        item.isSelected = true;
        this.subscribe = false;
        this.inService = false;
        if (item.name == "未到货") {
          this.params.isArrival = false;
        } else {
          delete this.params.isArrival;
        }
        if (item.name == "待预约") {
          this.subscribe = true;
          this.inService = false;
        }
        if (item.name == "服务中") {
          this.subscribe = false;
          this.inService = true;
        }
        if (item.name == "异常订单") {
          this.params.isGoodsAbnormal = true;
        } else {
          this.params.isGoodsAbnormal = "";
        }
        this.params.status = item.status;
        this.orderSearch();
      },
      // 搜索
      isorderSearch() {
        this.params.pageNum = 1;
        this.orderSearch();
      },
      // 订单接口调用
      orderSearch() {
        var _this = this;
        var params = {};
        if (this.flag == 1) {
          // console.log(this.$route.params)
          if (this.$route.params.isFinish === false) this.params.isFinish = false
          // 判断首页订单跳转状态
          if (this.$route.params.status !== undefined) {
            for (let i of this.orderType) {
              i.isSelected = false;
            }
            for (let i of this.orderType) {
              if (this.$route.params.status === i.status) {
                i.isSelected = true;
                this.params.status = this.$route.params.status;
              }
            }

            if (this.$route.params.status == "WAIT_PAY")
              this.$refs.orderList.batchPayBtn = true;

            // 待验收
            if (this.$route.params.status === "WAIT_ACCEPT") {
              this.params.status = "WAIT_ACCEPT";
              this.orderType.map((i) => {
                if (i.name == "待验收") {
                  i.isSelected = true;
                }
              });
            }
            // 待评价
            if (this.$route.params.status === "WAIT_EVALUATE") {
              this.params.status = "WAIT_EVALUATE";
              this.orderType.map((i) => {
                if (i.name == "待评价") {
                  i.isSelected = true;
                }
              });
            }

            // 服务中
            if (this.$route.params.status === "INSERVICE") {
              this.params.status = "INSERVICE";
              this.orderType.map((i) => {
                if (i.name == "服务中") {
                  i.isSelected = true;
                  this.inServiceList.map((i) => {
                    i.isSelected = false;
                    if (i.name == "全部") {
                      i.isSelected = true;
                      this.subscribe = false;
                      this.inService = true;
                    }
                  });
                }
              });
            }

            // 未到货
            if (this.$route.params.status === "NOT_ARRIVAL") {
              this.params.isArrival = false;
              this.orderType.map((i) => {
                if (i.name == "未到货") {
                  i.isSelected = true;
                }
              });
            }
            // 异常订单
            if (this.$route.params.status === "ABNORMAL") {
              this.params.isGoodsAbnormal = true;
              this.orderType.map((i) => {
                if (i.name == "异常订单") {
                  i.isSelected = true;
                }
              });
            }
          }
          if (this.$route.params.customer !== undefined) {
            this.params.customer = this.$route.params.customer;
          }
          if (this.$route.params.orderNum !== undefined) {
            this.params.orderNo = this.$route.params.orderNum;
          }
          if (this.$route.params.logisticsNo !== undefined) {
            this.params.logisticsNo = this.$route.params.logisticsNo;
          }
          this.flag = 2;
        }
        _this.params.startTime = _this.timeSlot[0];
        if (_this.timeSlot[1]) {
          _this.params.endTime = _this.timeSlot[1].split(" ")[0] + " 23:59:59";
        }
        // 完工时间
        _this.params.completeStartTime = _this.completeTime[0];
        if (_this.completeTime[1]) {
          _this.params.completeEndTime = _this.completeTime[1].split(" ")[0] + " 23:59:59";
        }
        if (this.params.areaCodeList) {
          this.params.areaCode =
            this.params.areaCodeList[this.params.areaCodeList.length - 1];
          // delete this.params.areaCodeList
        }

        for (let i in _this.params) {
          if (_this.params[i].length != 0) {
            params[i] = _this.params[i];
          }
        }

        this.$refs.orderList.loading = true;

        this.$fetch(`/order/api/order`, params)
          .then((res) => {
            if (res.code == 0) {
              res.data.refund = false;
              let multipleSelection = _this.$refs.orderList.multipleSelection;
              res.data.rows.map((i) => {
                if (multipleSelection.includes(i.id)) i.checked = true;
                else i.checked = false;
              });
              _this.orderItems = res.data;
            } else {
              this.$message(res.message);
            }
          })
          .finally(() => {
            this.$refs.orderList.loading = false;
          });
      },
      // 清除条件
      orderClear() {
        for (let i in this.params) {
          this.params[i] = "";
        }
        this.timeSlot = ["", ""];
        this.completeTime = ['', ''];
        this.params.pageNum = 1;
        this.params.pageSize = 6;
        this.subscribe = false;
        this.inService = false;
        this.orderType.map((i) => {
          i.isSelected = false;
          i.name == "全部" ? (i.isSelected = true) : "";
        });
        this.subscribeList.map((i) => {
          i.isSelected = false;
          i.name == "全部" ? (i.isSelected = true) : "";
        });
        this.inServiceList.map((i) => {
          i.isSelected = false;
          i.name == "全部" ? (i.isSelected = true) : "";
        });
        this.orderSearch();
      },
      subscribeCheck(item) {
        for (let i of this.subscribeList) {
          i.isSelected = false;
        }
        item.isSelected = true;
        if (item.name == "全部") {
          this.params.isArrival = true;
        } else {
          this.params.isArrival = false;
        }
        this.orderSearch();
      },
      inServiceCheck(item) {
        for (let i of this.inServiceList) {
          i.isSelected = false;
        }
        item.isSelected = true;
        this.params.status = item.status;
        this.orderSearch();
      },
    },
  };
</script>
<style lang="scss" scoped>
  .condition {
    // height: 288px;
    background: #fff;

    .order_steps {
      height: 108px;
      padding: 24px 101px;
      // border-bottom: 1px solid #e8eef5;
      background: url("~@/assets/img/pic_xiadanliucheng.png") no-repeat;
      background-size: cover;

      img {
        width: 679px;
        height: 32px;
        display: block;
        margin: 0 auto;
      }

      .steps_text {
        display: flex;
        justify-content: space-between;

        div {
          width: 48px;
          height: 12px;
          font-size: 12px;
          line-height: 1;
          color: #b4b7bc;
          margin-top: 16px;
          text-align: center;
        }
      }
    }

    .screen_input {
      // padding: 0 20px 0 20px;
      padding: 20px 20px 0;

      // height: 170px;
      &>div {
        margin-bottom: 16px;
        width: 286px;
      }

      .screen {
        // width: 210px;
        width: 230px;
        height: 34px;
        line-height: 34px;

        &/deep/input {
          height: 34px;
          // padding: 0 !important;
          line-height: 0;
        }
      }

      &::after {
        content: "";
        display: block;
        width: 286px;
      }
    }

    &/deep/.order_btns {
      padding: 0 20px 20px;

      a {
        color: #3455d3;
      }

      .el-button+.el-button {
        margin-left: 16px;
      }
    }

    .order_search {
      // width: 124px;
      width: 106px;
      height: 34px;
      background: #3455d3;
      border-color: #3455d3;
      border-radius: 2px;
      font-size: 14px;
      line-height: 5px;
      color: #fff;

      &:hover {
        background: #2c4abb;
        border-color: #2c4abb;
      }
    }

    .order_clear {
      width: 106px;
      height: 34px;
      border-radius: 2px;
      border: 1px solid rgba(180, 183, 188, 1);
      color: #5e6066;
      font-size: 14px;
      line-height: 5px;

      &:focus,
      &:hover {
        color: #3455d3;
        border-color: #3455d3;
        background: #fff;
      }
    }
  }

  .check_type {
    padding: 10px 20px;
    display: flex;
    flex-wrap: wrap;
    // padding-bottom: 5px;
    border-bottom: 1px solid #e8eef5;

    // height: 45px;
    .check_item {
      margin-right: 36px;
      color: #2f3133;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        color: #3455d3;
      }
    }

    .erji_item {
      width: 100%;

      // margin-top: 8px;
      .er_btns {
        width: 56px;
        height: 26px;
        color: #909399;
        font-size: 12px;
        border-radius: 13px;
        background: #f9fafa;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border: none;
        line-height: 0;

        &:hover {
          background: #f8f9fe;
          color: #3455d3;
        }
      }

      .er_selected {
        background: #f8f9fe;
        color: #3455d3;
      }
    }

    .order_type_isSelected {
      color: #3455d3;
      font-weight: bold;
      border-bottom: 1px solid #3455d3;
      padding-bottom: 3px;
    }
  }
</style>